import React from 'react';
import Utils from '../shared/Utils';

const YearTermSwitcher = ({ fetching, yearsAndTerms, activeYearTermCombo, ...props }) => {
  const formYearTermLink = (year, term_as_int) => {
    const { active_exam_level } = props;
    return `/home/results?year=${year}&term_as_int=${term_as_int}&exam_level=${active_exam_level}`;
  };

  const determineActiveYearTerm = (year, term_as_int) => {
    const { active_year, active_term_as_int } = props;
    if (active_year === year.toString() && active_term_as_int == term_as_int.toString()) {
      return ' active';
    }

    return '';
  };

  const fetchingClass = fetching ? ' disabled-element' : '';
  const rowClass = 'row align-items-center justify-content-center';
  const cardClass = 'card select-box text-center small-text space-bottom-small';
  const selectClass = 'custom-select custom-select-redirect medium-text space-top-small space-bottom-small';

  return (
    <React.Fragment>
      {/* Desktop Version */}
      <div className={`${rowClass} d-none d-lg-flex${fetchingClass}`}>
        {yearsAndTerms.map((data, index) => {
          const activeClass = determineActiveYearTerm(data.year, data.term_as_int);
          const link = formYearTermLink(data.year, data.term_as_int);
          return (
            <div key={`select-year-term-box-${index}`} className='col-md-3 col-sm-6'>
              <div className={`${cardClass}${activeClass}`}>
                <a
                  className='push-small'
                  href={link}
                  children={[data.year, Utils.getTerm(data.term_as_int)].join(' ')}
                />
              </div>
            </div>
          );
        })}
      </div>

      {/* Mobile Version */}
      <div className={`${rowClass} d-lg-none${fetchingClass}`}>
        <select className={selectClass} defaultValue={activeYearTermCombo}>
          {yearsAndTerms.map((data, index) => (
            <option
              key={`custom-year-term-select-option-${index}`}
              className='custom-select-option'
              data-href={formYearTermLink(data.year, data.term_as_int)}
              value={[data.year, Utils.getTerm(data.term_as_int)].join(' ')}
              children={[data.year, Utils.getTerm(data.term_as_int)].join(' ')}
            />
          ))}
        </select>
      </div>
    </React.Fragment>
  );
}

export default YearTermSwitcher;
